export default __webpack_public_path__ + "static/media/frame-register@2x.2cb48902.png";